import { Row, Col, Image } from "antd";
import { StyledContainer } from "./StyledContainer";
import { FaFacebook, FaInstagram, FaPhone, FaRegEnvelope, FaTiktok, FaTwitter, FaWhatsapp } from 'react-icons/fa'
import webUi from "../../apis/webUi";

import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  FooterContainer,
} from "./styles";
import { Text } from '@chakra-ui/react';

interface SocialLinkProps {
  href: string;
  icon: React.ReactNode;
}

const Footer = () => {

  const SocialLink = ({ href, icon }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={href}
        aria-label={href}
      >
        {icon}
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <StyledContainer>
          <Row justify="space-between">
            <Col lg={6} md={6} sm={12} xs={12}>
              <Title>{"Policies"}</Title>
              <Large to={`${webUi}/privacy-policy`} target="_blank">{"Privacy"}</Large>
              <Large to={`${webUi}/partnership-pages-policy`} target="_blank">{"Partnership & Pages"}</Large>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Title>{"Locations"}</Title>
              <Para>Portmore, Jamaica</Para>
              <Para>Mandeville, Jamaica</Para>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Title>{"Contact"}</Title>
              <Para>(876) 485-6559</Para>
              <Para>hello@goshowfa.com</Para>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Title>{"Company"}</Title>
              {/* <Large to="/">{t("Press")}</Large> */}
              <Large to={`${webUi}/jobs`} target="_blank">{"Jobs"}</Large>
            </Col>
          </Row>
        </StyledContainer>
      </FooterSection>
      <Extra>
        <StyledContainer>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
              <Image
                src="/assets/images/showfa-logo.png"
                alt="Showfa Logo"
                height="30px"
                width="161px"
              /> 
              </LogoContainer>
            </NavLink>
            <FooterContainer>
              <SocialLink
                href="tel:+18764856559"
                icon={<FaPhone size={20}/>}
              />
              <SocialLink
                href="mailto:hello@goshowfa.com"
                icon={<FaRegEnvelope size={20}/>}
              />
              <SocialLink
                href="https://twitter.com/goshowfa"
                icon={<FaTwitter size={20}/>}
              />
              <SocialLink
                href="https://www.tiktok.com/@goshowfa"
                icon={<FaTiktok size={20}/>}
              />
              <SocialLink
                href="https://www.facebook.com/goshowfa"
                icon={<FaFacebook size={20}/>}
              />
              <SocialLink
                href="https://www.instagram.com/goshowfa"
                icon={<FaInstagram size={20}/>}
              />
              <SocialLink
                href="https://wa.me/+18764856559"
                icon={<FaWhatsapp size={20}/>}
              />
            </FooterContainer>
          </Row>
        </StyledContainer>
      </Extra>
      <Extra>
        <StyledContainer>
          <Row>
          <Text>© {new Date().getFullYear()} Showfa Express Limited. All rights reserved</Text>
          </Row>
        </StyledContainer>
      </Extra>
    </>
  );
};

export default Footer;
